export const uploadScript = (container: string, url: string, onload?: any) => {
  const elements = [...document.getElementsByClassName(container)]
  const script = document.createElement('script')
  if (onload) {
    script.onload = onload
  }
  script.src = url
  script.async = true

  if (elements.length) {
    elements.forEach((element) => {
      element.appendChild(script)
    })
  }
}
